module.exports = __webpack_public_path__ + "static/media/logo-visa.0d1fbbc4.svg";